"use client";

import clsx from "clsx";

interface TagProps {
  value: string;
}

// Mapa de colores con clave consistente en PascalCase
const colorMap: Record<string, { text: string; bg: string }> = {
  FullTime: { text: "text-[#2F80ED]", bg: "bg-[#E6F4EA]" },
  FullTimeHyphen: { text: "text-[#2F80ED]", bg: "bg-[#E6F4EA]" }, // para "Full-Time"
  Remote: { text: "text-[#5B02FF]", bg: "bg-[#E9D9FF]" },
  Expert: { text: "text-[#FDAA2B]", bg: "bg-[#FFEAEA]" },
};

// Función para normalizar la clave: elimina guiones y pone PascalCase simple
const normalizeKey = (value: string) => {
  return value
    .replace(/-/g, "") // quitar guiones
    .toLowerCase()
    .replace(/(^\w|[A-Z]|\b\w)/g, (match) => match.toUpperCase())
    .replace(/\s+/g, "");
};

export const Tag = ({ value }: TagProps) => {
  const normalizedValue = normalizeKey(value);

  // Buscar la clave normalizada en el mapa, considerando "FullTime" y "FullTimeHyphen"
  const foundKey = Object.keys(colorMap).find(
    (key) => key.toLowerCase() === normalizedValue.toLowerCase()
  );

  const { text, bg } = foundKey
    ? colorMap[foundKey]
    : { text: "text-[#8A8A8A]", bg: "bg-[#F5F5F5]" };

  return (
    <span
      className={clsx(
        "min-w-[55px] lg:min-w-[60px]",
        "h-[18px] lg:h-[20px]",
        "px-[6px]",
        "text-[10px] lg:text-[12px]",
        "font-semibold rounded-[5px]",
        "flex items-center justify-center",
        text,
        bg
      )}
    >
      {value}
    </span>
  );
};
